import Vue from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';

import './sass/main.sass';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueCookie = require('vue-cookie');

Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_TRACKING_ID,
  },
  bootstrap: false,
});

new Vue({
  render: (h) => h(App),
}).$mount('#app');
